import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const LinkedIn = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 24 24" ref={ref} {...props}>
      <path d="M0.389887 7.85834H5.30484V23.6672H0.389887V7.85834ZM2.8475 0C4.41837 0 5.69499 1.27662 5.69499 2.85013C5.69499 4.42206 4.41837 5.69868 2.8475 5.69868C1.27293 5.69868 0 4.42206 0 2.85013C0 1.27662 1.27293 0 2.8475 0Z" />
      <path d="M8.38654 7.85839H13.0994V10.0202H13.1666C13.8226 8.77673 15.4258 7.46692 17.8155 7.46692C22.791 7.46692 23.7094 10.7401 23.7094 14.9968V23.6673H18.7981V15.9794C18.7981 14.1456 18.7662 11.7876 16.2449 11.7876C13.688 11.7876 13.2978 13.7863 13.2978 15.8477V23.6673H8.38654V7.85839Z" />
    </SvgIcon>
  );
});

LinkedIn.displayName = "LinkedIn";

export default LinkedIn;
